import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import styled from "styled-components";
import { useSelector } from "react-redux";

import { OwnershipOptions, PublishingOptions } from "./ProductSearchOptions";
import FormInputField, {
  FormInputFieldType,
} from "common/formFields/FormInputField";
import FormSelectField from "common/formFields/FormSelectField";
import Button, {
  ButtonType,
  ButtonVariant,
} from "common/basicComponents/Button";
import { constantToSelect } from "utils/FormUtils";

const Container = styled.div`
  display: flex;
  gap: 1.25rem;
  align-items: flex-end;

  & > *:not(button) {
    flex-grow: 1;
    flex-basis: 0;
    max-height: 4.125rem;
    white-space: nowrap;
  }
`;

const DesktopSearchForm = () => {
  const { t } = useTranslation("product");
  const { partner } = useSelector((state) => state.auth);
  const { resetForm, isSubmitting } = useFormikContext();

  useEffect(() => {
    resetForm();
  }, [partner, resetForm]);

  return (
    <Container>
      <FormInputField
        id="productName"
        name="productName"
        label={t("name")}
        disabled={isSubmitting}
        type={FormInputFieldType.TEXT}
      />
      {!partner?.main_partner && (
        <FormSelectField
          id="owner"
          name="owner"
          label={t("search.owner")}
          disabled={isSubmitting}
          options={constantToSelect(OwnershipOptions, "product:search")}
        />
      )}
      <FormSelectField
        id="status"
        name="status"
        label={t("search.status")}
        disabled={isSubmitting}
        options={constantToSelect(PublishingOptions, "product:search")}
      />

      <Button
        type={ButtonType.SUBMIT}
        minWidth="100px"
        disabled={isSubmitting}
        text={t("common:button.search")}
      />
      <Button
        type={ButtonType.SUBMIT}
        variant={ButtonVariant.OUTLINED}
        minWidth="100px"
        onClick={() => {
          resetForm();
        }}
        text={t("common:button.clear")}
      />
    </Container>
  );
};

export default DesktopSearchForm;
